import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import * as DateHelpers from './DateHelpers';
import { toast } from 'react-toastify';
import ConfirmPopup from './ConfirmPopup';
import * as Utils from './Utils';
import { PostQuery } from './Shared';

interface AllocateMultiTrucksProps {
    multipleTrucksItem: MultipleTrucksItem;
    truckOptions: TruckListOption[];
    showModal: boolean;
    hideModal(): void;
    updateData(multipleTrucksItem: MultipleTrucksItem): void;
    save(): void;
}

interface AllocateMultiTrucks {
    showTruckRemoveConfirmModal: boolean;
    truckIndex: number;
    selectedTruckId: number;
    showConfirmModal: boolean;
    deleteIndex: number;
    errors: any;
    loading: boolean;
}

interface MultipleTrucksItem {
    rowIndex: number;
    jobId: string;
    id: number;     //schedule id of the item we are editing
    itemId: number;
    item: string;
    originalTotal: number;
    originalKwikstage: KwikstageOriginalItem[];
    originalTruckId: number;
    selectedTrucks: TruckListOption[];
    formula: number;
    size: number;
    voidSizeMin: number;
    itemVoidExtraTime: number;
    multipleTrucks: MultipleTrucks[];
    isKwikstage: boolean;
    isVoid: boolean;
    scheduleType: number;
    extraHours: number;
}

interface KwikstageOriginalItem {
    jobQuoteItemCalculationId: number;
    starterBayId: number;
    starterBay: string;
    liftId: number;
    lift: string;
    bays: number;
    baysTotal: number;
}

interface MultipleTrucks {
    scheduleId: number;     //schedule id as once saved, each allocation will have its own schedule id
    truckId: number;
    truckNumberTeamMembers: number;
    startTime: string;
    quantityTotal: number;
    quantityScheduled: number;
    estimatedTime: string;
    estimatedTimeMins: number;
    updateOrder: boolean;
    vehicleItemOrder: number;
    kwikstageItems: KwikstageScheduleItem[];
}

interface KwikstageScheduleItem {
    scheduleKwikstageId: number;
    jobQuoteItemCalculationId: number;
    starterBayId: number;
    starterBay: string;
    liftId: number;
    lift: string;
    bays: number;
    baysTotal: number;
}

interface TruckListOption {
    id: number;
    branchId: number;
    name: string;
    registrationNumber: string;
    scheduleVehicleId: number;
    teamDisplay: string;
    numberTeamMembers: number;
}

interface QuantityEstTime {
    quantity: number;
    estTime: string;
    estTimeMins: number;
}

export default class AllocateMultiTrucksModal extends React.Component<AllocateMultiTrucksProps, AllocateMultiTrucks> {
    constructor(props: AllocateMultiTrucksProps) {
        super(props);
        this.state = {
            showTruckRemoveConfirmModal: false,
            truckIndex: 0,
            selectedTruckId: -1,
            showConfirmModal: false,
            deleteIndex: 0,
            errors: {},
            loading: false
        }
    }

    hideModal = () => {
        this.props.hideModal();
    }

    onCellChange = (e: any, itemIndex: number) => {
        var multipleTrucksItem = this.props.multipleTrucksItem;
        var multipleTrucks = multipleTrucksItem.multipleTrucks;
        var item = multipleTrucks[itemIndex];

        let newItem: any = {};
        newItem = item;
        newItem[e.target.name] = e.target.value;
        
        if (e.target.name === "quantityScheduled") {
            var value = e.target.value * 1;

            var truckNoPpl = 3;
            var truck = this.props.truckOptions.find(t => t.id === item.truckId);
            if (truck) {
                truckNoPpl = truck.numberTeamMembers;
            }

            //recalculate the estimated time
            var estTime = "";
            if (multipleTrucksItem.isVoid) {
                estTime = Utils.calculateVoidEstimatedTime(true, value, multipleTrucksItem.size, truckNoPpl, multipleTrucksItem.voidSizeMin, multipleTrucksItem.formula, multipleTrucksItem.itemVoidExtraTime, multipleTrucksItem.scheduleType, multipleTrucksItem.extraHours);
            } else {
                estTime = Utils.calculateEstimatedTime(value, truckNoPpl, multipleTrucksItem.formula, multipleTrucksItem.scheduleType, multipleTrucksItem.extraHours);
            }
            var estTimeMins = DateHelpers.convertTimeToMins(estTime);
            item.estimatedTime = estTime;
            item.estimatedTimeMins = estTimeMins;
        }

        this.props.updateData(multipleTrucksItem);
    }

    onKwikstageCellChange = (e: any, itemIndex: number, ksItemIndex: number) => {
        var bays = e.target.value * 1;
        var ksName = e.target.name;

        this.getKwikstageMetres(itemIndex, ksItemIndex, ksName, bays);
    }

    getKwikstageMetres = async (itemIndex: number, ksItemIndex: number, ksName: string, bays: number) => {
        var multipleTrucksItem = this.props.multipleTrucksItem;
        var multipleTrucks = multipleTrucksItem.multipleTrucks;
        var item = multipleTrucks[itemIndex];
        var ksItems = item.kwikstageItems;
        var ksItem = ksItems[ksItemIndex];

        let newItem: any = {};
        newItem = ksItem;
        newItem[ksName] = bays;
        
        var jsonItem = JSON.stringify(ksItems);
        const apiUrl = "GetKwikstageMetres";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error getting KS quantity!");
        } else {
            var quantity = result.data;
            item.quantityScheduled = quantity;
            //calculate estimated time
            let estTime = Utils.calculateEstimatedTime(quantity, item.truckNumberTeamMembers, multipleTrucksItem.formula, multipleTrucksItem.scheduleType, multipleTrucksItem.extraHours);
            item.estimatedTime = estTime;
            let estTimeMins = DateHelpers.convertTimeToMins(estTime);
            item.estimatedTimeMins = estTimeMins;

            this.props.updateData(multipleTrucksItem);
        }
    }

    handleTruckChange = (e: any) => {
        var multipleTrucksItem = this.props.multipleTrucksItem;
        var selectedTrucks = multipleTrucksItem.selectedTrucks;

        var truckId = e.target.value * 1;
        var newTruck = this.props.truckOptions.find(t => t.id === truckId);
        if (newTruck) {
            selectedTrucks.push(newTruck);
        }

        //calculate times
        this.calculate(selectedTrucks, multipleTrucksItem);

        this.setState({ errors: {} });
        this.props.updateData(multipleTrucksItem);
    }

    //REMOVE TRUCK ALLOCATION
    removeTruck = (truckIndex: number) => {
        this.setState({ showTruckRemoveConfirmModal: true, truckIndex: truckIndex });
    }

    hideTruckRemoveConfirmModal = () => {
        this.setState({ showTruckRemoveConfirmModal: false, truckIndex: 0 });
    }

    saveTruckRemoveConfirmModal = () => {
        let multipleTrucksItem = this.props.multipleTrucksItem;
        let selectedTrucks = multipleTrucksItem.selectedTrucks;
        let truckToRemove = selectedTrucks[this.state.truckIndex];

        //remove from truck list
        let multipleTrucks = multipleTrucksItem.multipleTrucks;
        let truckToRemoveIndex = multipleTrucks.findIndex(t => t.truckId === truckToRemove.id);
        if (truckToRemoveIndex) {
            let truck = multipleTrucks[truckToRemoveIndex];
            if (truck.scheduleId === 0) {
                multipleTrucks.splice(truckToRemoveIndex, 1);
                //remove from selected trucks list
                selectedTrucks.splice(this.state.truckIndex, 1);
                this.props.updateData(multipleTrucksItem);
                this.setState({ showTruckRemoveConfirmModal: false, truckIndex: 0 });

                //recalculate
                this.calculate(selectedTrucks, multipleTrucksItem);
            } else {
                this.deleteMultiTruck(truckToRemoveIndex, truck.scheduleId, multipleTrucksItem, selectedTrucks, multipleTrucks);
            }
        } else {
            this.setState({ showTruckRemoveConfirmModal: false, truckIndex: 0 });

            //recalculate
            this.calculate(selectedTrucks, multipleTrucksItem);
        }      
    }

    deleteMultiTruck = async (truckToRemoveIndex: number, scheduleId: number, multipleTrucksItem: MultipleTrucksItem, selectedTrucks: TruckListOption[], multipleTrucks: MultipleTrucks[]) => {
        var deleteItem = {
            scheduleId: scheduleId,
            jobId: multipleTrucksItem.jobId,
            itemId: multipleTrucksItem.itemId,
            item: multipleTrucksItem.item
        };

        var jsonItem = JSON.stringify(deleteItem);

        const apiUrl = "DeleteMultipleTruckAllocation";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error deleting truck!");
        } else {
            multipleTrucks.splice(truckToRemoveIndex, 1);
            selectedTrucks.splice(this.state.truckIndex, 1);
            this.props.updateData(multipleTrucksItem);
            toast.success("Item removed successfully");

            this.calculate(selectedTrucks, multipleTrucksItem);
            this.setState({ showConfirmModal: false, deleteIndex: 0, showTruckRemoveConfirmModal: false, truckIndex: 0 });
        }
    }

    //END REMOVE TRUCK ALLOCATION

    //DELETE ALLOCATION
    deleteItem = (e: any, itemIndex: number) => {
        e.preventDefault();

        this.setState({ showConfirmModal: true, deleteIndex: itemIndex });
    }

    hideConfirmModal = () => {
        this.setState({ showConfirmModal: false, deleteIndex: 0 });
    }

    saveConfirmModal = () => {
        //delete from multiple truck allocation, leave schedule item
        let multipleTrucksItem = this.props.multipleTrucksItem;
        let multipleTrucks = multipleTrucksItem.multipleTrucks;
        let multipleTruck = multipleTrucks[this.state.deleteIndex];
        let selectedTrucks = multipleTrucksItem.selectedTrucks;
        //remove truck from selectedTrucks
        var truckIndex = selectedTrucks.findIndex(t => t.id === multipleTruck.truckId);
        if (truckIndex >= 0) {
            selectedTrucks.splice(truckIndex, 1);
        }

        if (multipleTruck.scheduleId === 0) {
            //remove as not yet saved
            multipleTrucks.splice(this.state.deleteIndex, 1);
            this.props.updateData(multipleTrucksItem);
            toast.success("Item removed successfully");
            
            this.calculate(selectedTrucks, multipleTrucksItem);
            this.setState({ showConfirmModal: false, deleteIndex: 0 });
        } else {
            this.saveDeleteMultiple(multipleTrucksItem, multipleTrucks, selectedTrucks);
        }
    }

    saveDeleteMultiple = async (multipleTrucksItem: MultipleTrucksItem, multipleTrucks: MultipleTrucks[], selectedTrucks: TruckListOption[]) => {
        let multipleTruck = multipleTrucks[this.state.deleteIndex];
        var deleteItem = {
            scheduleId: multipleTruck.scheduleId,
            jobId: multipleTrucksItem.jobId,
            itemId: multipleTrucksItem.itemId,
            item: multipleTrucksItem.item
        };

        var jsonItem = JSON.stringify(deleteItem);

        const apiUrl = "DeleteMultipleTruckAllocation";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error deleting truck!");
        } else {
            multipleTrucks.splice(this.state.deleteIndex, 1);
            toast.success("Item removed successfully");

            this.calculate(selectedTrucks, multipleTrucksItem);
            this.setState({ showConfirmModal: false, deleteIndex: 0 });
        }
    }
    //END DELETE ALLOCATION

    calculate = (selectedTrucks: TruckListOption[], multipleTrucksItem: MultipleTrucksItem) => {
        let multipleTrucks = multipleTrucksItem.multipleTrucks;
        let totalQty = multipleTrucksItem.originalTotal;
        let totalNoPeople = this.getTotalTruckTeamMembers(selectedTrucks);
        let extraHours = multipleTrucksItem.extraHours; //only want to add this on once

        if (multipleTrucksItem.isKwikstage) {
            this.calculateKwikstage(selectedTrucks, multipleTrucksItem);
        } else {
            if (multipleTrucksItem.formula > 0) {
                //Note: can't calculate quantity or times if 0 so only update when > 0
                //loop through each truck and update the quantity and estimated times
                var addIndividalTotal = 0;
                for (var i = 0; i < selectedTrucks.length; i++) {
                    let quantityScheduled = 0;
                    let estimatedTime = "";
                    let estimatedTimeMins = 0;
                    
                    if (multipleTrucksItem.isVoid) {
                        let useMin = extraHours === 0;  //if there are extra hours then want to ignore setting the min 20 minutes until later
                        let qtyEstTime = this.calculateVoidQuantityEstTime(useMin, totalQty, totalNoPeople, selectedTrucks[i].numberTeamMembers, multipleTrucksItem.size, multipleTrucksItem.voidSizeMin, multipleTrucksItem.formula, multipleTrucksItem.itemVoidExtraTime, multipleTrucksItem.scheduleType, 0);
                        quantityScheduled = qtyEstTime.quantity;
                        estimatedTime = qtyEstTime.estTime;
                        estimatedTimeMins = qtyEstTime.estTimeMins;

                        //split extra hours across all the trucks evenly
                        if (extraHours > 0) {
                            let extraHoursMins = Utils.CalculateExtraHoursMinutes(multipleTrucksItem.scheduleType, extraHours);
                            let extrHoursMinsTruck = extraHoursMins / selectedTrucks.length;    //mins per truck extra to add
                            var estTimeExtra = qtyEstTime.estTimeMins + extrHoursMinsTruck;    //update estimated time with extra hours
                            if (estTimeExtra < 20) {
                                estTimeExtra = 20;
                            }
                            estimatedTimeMins = estTimeExtra;
                            estimatedTime = DateHelpers.convertMinsToHoursMinutes(estimatedTimeMins);
                        }
                    } else {
                        let qtyEstTime = this.calculateQuantityEstTime(totalQty, totalNoPeople, selectedTrucks[i].numberTeamMembers, multipleTrucksItem.formula, multipleTrucksItem.scheduleType, multipleTrucksItem.extraHours);
                        quantityScheduled = qtyEstTime.quantity;
                        estimatedTime = qtyEstTime.estTime;
                        estimatedTimeMins = qtyEstTime.estTimeMins;
                    }
                    //let estimatedTimeMins = DateHelpers.convertTimeToMins(estimatedTime);
                    addIndividalTotal += quantityScheduled;

                    //see if truck exists, if not add new
                    let multiTruck = multipleTrucks.find(t => t.truckId === selectedTrucks[i].id);
                    if (multiTruck) {
                        //update qty and estimated time
                        multiTruck.quantityScheduled = quantityScheduled;
                        multiTruck.estimatedTime = estimatedTime;
                        multiTruck.estimatedTimeMins = estimatedTimeMins;
                    } else {
                        //find truck details
                        var truck = this.props.truckOptions.find(t => t.id === selectedTrucks[i].id);

                        //add new
                        if (truck) {
                            let newMultiTruck: MultipleTrucks = {
                                scheduleId: 0,
                                truckId: selectedTrucks[i].id,
                                truckNumberTeamMembers: truck.numberTeamMembers,
                                startTime: "",
                                quantityTotal: multipleTrucksItem.originalTotal,
                                quantityScheduled: quantityScheduled,
                                estimatedTime: estimatedTime,
                                estimatedTimeMins: estimatedTimeMins,
                                updateOrder: true,
                                vehicleItemOrder: 0,
                                kwikstageItems: []
                            }
                            multipleTrucks.push(newMultiTruck);
                        }

                    }
                }

                //check if the individual quantites add up to the total quantity 
                //because 25 / 2 trucks = 12.5 it means both trucks will be allocated 13 each so need to set one to 13 and one to 12
                //and 25 / 3 trucks = 8.33 it means trucks will be allocated 8 each so need to set the first two to 8 and the last one to 9
                if (totalQty != addIndividalTotal) {
                    //get last item
                    var lastItem = multipleTrucks[multipleTrucks.length - 1];
                    //if individal total > total then minus 1 from last item
                    //else if individual total < total then add 1 to last item
                    if (addIndividalTotal > totalQty) {
                        lastItem.quantityScheduled -= 1;
                    } else if (addIndividalTotal < totalQty) {
                        lastItem.quantityScheduled += 1;
                    }
                    //need to recalculate the estimated time now that we have changed the quantity
                    var estTimeMins = Utils.calculateEstimatedTimeMins(lastItem.quantityScheduled, lastItem.truckNumberTeamMembers, multipleTrucksItem.formula, multipleTrucksItem.scheduleType, multipleTrucksItem.extraHours);
                    let estTime = DateHelpers.convertMinsToHoursMinutes(estTimeMins);

                    lastItem.estimatedTimeMins = estTimeMins;
                    lastItem.estimatedTime = estTime;
                }
            }
            this.props.updateData(multipleTrucksItem);
        }
        
    }

    calculateKwikstage(selectedTrucks: TruckListOption[], multipleTrucksItem: MultipleTrucksItem) {
        //need to get the actual quantity in metres to calculate kwikstage estimated time so need a separate function
        let multipleTrucks = multipleTrucksItem.multipleTrucks;
        let totalNoPeople = this.getTotalTruckTeamMembers(selectedTrucks);
        let origKsItems = multipleTrucksItem.originalKwikstage;

        var addIndividalTotals: KwikstageOriginalItem[] = [];
        //STEP 1: Calculate Updated/New Quantity
        for (var i = 0; i < selectedTrucks.length; i++) {
            //loop through original ks items to calculate new quantities
            let quantity = 0;
            for (var k = 0; k < origKsItems.length; k++) {
                let truckNoPeople = selectedTrucks[i].numberTeamMembers;
                let calcQuantity = (origKsItems[k].bays / totalNoPeople) * truckNoPeople;
                quantity = Math.round(calcQuantity * 1) / 1;
                let quantityTotal = origKsItems[k].baysTotal * 1;

                //update the quantity check
                var qtyCheck = addIndividalTotals.find(i => i.starterBayId === origKsItems[k].starterBayId && i.liftId === origKsItems[k].liftId);
                if (qtyCheck) {
                    qtyCheck.bays += quantity;
                } else {
                    let addIndividualTotal: KwikstageOriginalItem = {
                        jobQuoteItemCalculationId: origKsItems[k].jobQuoteItemCalculationId,
                        starterBayId: origKsItems[k].starterBayId,
                        starterBay: origKsItems[k].starterBay,
                        liftId: origKsItems[k].liftId,
                        lift: origKsItems[k].lift,
                        bays: quantity,
                        baysTotal: origKsItems[k].baysTotal
                    };
                    addIndividalTotals.push(addIndividualTotal);
                }

                //see if truck exists, if not add new
                //if the total quantity is 1 then don't add to the new truck
                if (quantityTotal > 1) {
                    let multiTruck = multipleTrucks.find(t => t.truckId === selectedTrucks[i].id);
                    if (multiTruck) {
                        //see if the ks item exists to update quantity
                        var ksItem = multiTruck.kwikstageItems.find(ks => ks.starterBayId === origKsItems[k].starterBayId && ks.liftId === origKsItems[k].liftId);
                        if (ksItem) {
                            //update the quantity
                            ksItem.bays = quantity;
                        } else {
                            //add new ks item
                            let newKsItem: KwikstageScheduleItem = {
                                scheduleKwikstageId: 0,
                                jobQuoteItemCalculationId: origKsItems[k].jobQuoteItemCalculationId,
                                starterBayId: origKsItems[k].starterBayId,
                                starterBay: origKsItems[k].starterBay,
                                liftId: origKsItems[k].liftId,
                                lift: origKsItems[k].lift,
                                baysTotal: origKsItems[k].baysTotal,
                                bays: quantity
                            };
                            multiTruck.kwikstageItems.push(newKsItem);
                        }
                    } else {
                        //add new
                        //find truck details
                        var truck = this.props.truckOptions.find(t => t.id === selectedTrucks[i].id);
                        var ksItems: KwikstageScheduleItem[] = [];
                        let newKsItem: KwikstageScheduleItem = {
                            scheduleKwikstageId: 0,
                            jobQuoteItemCalculationId: origKsItems[k].jobQuoteItemCalculationId,
                            starterBayId: origKsItems[k].starterBayId,
                            starterBay: origKsItems[k].starterBay,
                            liftId: origKsItems[k].liftId,
                            lift: origKsItems[k].lift,
                            baysTotal: origKsItems[k].baysTotal,
                            bays: quantity
                        };
                        ksItems.push(newKsItem);

                        //add new
                        if (truck) {
                            let newMultiTruck: MultipleTrucks = {
                                scheduleId: 0,
                                truckId: selectedTrucks[i].id,
                                truckNumberTeamMembers: truck.numberTeamMembers,
                                startTime: "",
                                quantityTotal: multipleTrucksItem.originalTotal,
                                quantityScheduled: quantity,
                                estimatedTime: "",
                                estimatedTimeMins: 0,
                                updateOrder: true,
                                vehicleItemOrder: 0,
                                kwikstageItems: ksItems
                            }
                            multipleTrucks.push(newMultiTruck);
                        }
                    }
                }
            }
        }

        //STEP 2: Check Quantities - Add / Remove as required due to rounding
        //loop through original ks items and compare with new ks items over trucks
        for (var x = 0; x < origKsItems.length; x++) {
            let origKsItem = origKsItems[x];
            let origBays = origKsItem.bays * 1;
            let qtyCheck = addIndividalTotals.find(i => i.starterBayId === origKsItem.starterBayId && i.liftId === origKsItem.liftId);
            if (qtyCheck) {
                let newBays = qtyCheck.bays * 1;
                if (newBays != origBays) {
                    var multiTruck = multipleTrucks[multipleTrucks.length - 1]; //get last truck
                    var multiKsItem = multiTruck.kwikstageItems.find(i => i.starterBayId === origKsItem.starterBayId && i.liftId === origKsItem.liftId);
                    if (multiKsItem) {
                        if (newBays > origBays) {
                            //remove an item
                            multiKsItem.bays -= 1;
                        } else if (newBays < origBays) {
                            //add an item
                            multiKsItem.bays += 1;
                        }
                    }

                }
            }
        }

        //STEP 3: Calculate Estimated Times
        this.calcKwikstageMutliple(multipleTrucksItem);
    }

    async calcKwikstageMutliple(multipleTrucksItem: MultipleTrucksItem) {
        var jsonItem = JSON.stringify(multipleTrucksItem);

        const apiUrl = "CalculateKwikstageMultipleTrucks";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error calculating KS!");
        } else {
            let multipleTrucks = result.data;
            multipleTrucksItem.multipleTrucks = multipleTrucks;
            this.props.updateData(multipleTrucksItem);
        }
    }

    calculateQuantityEstTime = (totalQty: number, totalTruckNoPeople: number, truckNoPeople: number, formula: number, scheduleType: number, extraHours: number) => {
        let quantity = (totalQty / totalTruckNoPeople) * truckNoPeople;
        quantity = Math.round(quantity * 1) / 1;

        var estTimeMins = Utils.calculateEstimatedTimeMins(quantity, truckNoPeople, formula, scheduleType, extraHours);
        let estTime = DateHelpers.convertMinsToHoursMinutes(estTimeMins);

        let qtyEstTime: QuantityEstTime = {
            quantity: quantity,
            estTime:  estTime.toString(),
            estTimeMins: estTimeMins
        };

        return qtyEstTime;
    }

    calculateVoidQuantityEstTime = (useMin: boolean, totalQty: number, totalTruckNoPeople: number, truckNoPeople: number, size: number, voidSizeMin: number, voidFormulaMins: number, voidSizeExtraTime: number, scheduleType: number, extraHours: number) => {
        //work out the quantity, then use the normal function to calculate the est time as void is different
        let quantity = (totalQty / totalTruckNoPeople) * truckNoPeople;
        quantity = Math.round(quantity * 1) / 1;

        let estTime = Utils.calculateVoidEstimatedTime(useMin, quantity, size, truckNoPeople, voidSizeMin, voidFormulaMins, voidSizeExtraTime, scheduleType, extraHours);
        let estimatedTimeMins = DateHelpers.convertTimeToMins(estTime);
        let qtyEstTime: QuantityEstTime = {
            quantity: quantity,
            estTime: estTime,
            estTimeMins: estimatedTimeMins
        };

        return qtyEstTime;
    }

    getTotalTruckTeamMembers = (selectedTrucks: TruckListOption[]) => {
        var total = 0;
        for (var i = 0; i < selectedTrucks.length; i++) {
            total += selectedTrucks[i].numberTeamMembers;
        }
        return total;
    }

    save = (e: any) => {
        e.preventDefault();

        this.props.save();
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return (<div>
            {contents}
        </div>);
    }

    renderDetails = () => {
        let multipleTrucksItem = this.props.multipleTrucksItem;
        let originalKwikstageItems = multipleTrucksItem.originalKwikstage;
        let multipleTrucks = multipleTrucksItem.multipleTrucks;
        let truckOptions = this.props.truckOptions;
        let truckOptionsFiltered = this.props.truckOptions.filter(t => t.id != this.props.multipleTrucksItem.originalTruckId);
        let selectedTrucks = multipleTrucksItem.selectedTrucks;

        let confirmPopup = <ConfirmPopup heading="Delete Truck Allocation?" text="Are you sure you want to delete this truck allocation?" hideConfirmModal={this.hideConfirmModal} showConfirmModal={this.state.showConfirmModal} saveConfirmModal={this.saveConfirmModal} />
        let confirmRemoveTruckPopup = <ConfirmPopup heading="Delete Truck Allocation?" text="Are you sure you want to delete this truck allocation?" hideConfirmModal={this.hideTruckRemoveConfirmModal} showConfirmModal={this.state.showTruckRemoveConfirmModal} saveConfirmModal={this.saveTruckRemoveConfirmModal} />

        return (
            <div className="static-modal">
                {confirmPopup}
                {confirmRemoveTruckPopup}
                <Modal show={this.props.showModal} onHide={this.hideModal}>
                    <Modal.Header className="modal__header--colour">
                        <Modal.Title>Allocate Truck for {multipleTrucksItem.item}</Modal.Title>
                        <button type="button" className="close" onClick={this.hideModal}>&times;</button>
                    </Modal.Header>
                    <Modal.Body>
                        <div className={multipleTrucksItem.isKwikstage ? "hidden" : ""}>
                            <label className="input-group" htmlFor="originalTotal">
                                <span className="label">Original Qty Total</span>
                                <input type='number' id="originalTotal" name="originalTotal" className='input' value={multipleTrucksItem.originalTotal} disabled></input>
                            </label>
                        </div>
                        <div className={multipleTrucksItem.isKwikstage ? "" : "hidden"}>
                            {originalKwikstageItems.map((item, index) =>
                                <div key={index}>
                                    <label className="label rollover-padding">
                                        {item.starterBay}
                                    </label>
                                    <label className="label rollover-padding">
                                        {item.lift}
                                    </label>
                                    <label className="label rollover-padding">
                                        {item.bays} bays
                                    </label>
                                </div>
                            )}
                        </div>

                        <label className="input-group" htmlFor="selectedTruckId">
                            <span className="label">Truck/s</span>
                            <select className="select" id="selectedTruckId" name="selectedTruckId" value={this.state.selectedTruckId} onChange={(e) => this.handleTruckChange(e)} >
                                <option defaultValue="-1"></option>
                                {truckOptionsFiltered.map(truck =>
                                    <option key={truck.id} value={truck.id}>{truck.name}-{truck.registrationNumber}</option>
                                )}
                            </select>
                        </label>

                        <label className="input-group" htmlFor="truck">
                            <span className="label"></span>
                            <div>
                                {selectedTrucks.map((truck, index) =>
                                    <div className="allocatepopup__nowrapItemText" key={truck.id} >
                                        <span className="input marginRight10">{truck.name}</span>
                                        <button type="button" className={truck.id === multipleTrucksItem.originalTruckId ? "hidden" : "close makeitred"} onClick={() => this.removeTruck(index)} >&times;</button>
                                        <br />
                                    </div>
                                )}
                            </div>
                        </label>

                        <div className="table__margin overflowAuto">
                            <table className="table table__small tableColours">
                                <thead>
                                    <tr>
                                        <th className="hidden">Id</th>
                                        <th></th>
                                        <th>Truck</th>
                                        <th>Quantity</th>
                                        <th>Time</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {multipleTrucks.map((item, index) =>
                                        <tr key={index}>
                                            <td className="hidden">{item.scheduleId}</td>
                                            <td className="table__text--align">{index + 1}</td>
                                            <td className="table__text--align">
                                                <select className="select" id="truckId" name="truckId" value={item.truckId} disabled >
                                                    <option defaultValue="-1"></option>
                                                    {truckOptions.map(truck =>
                                                        <option key={truck.id} value={truck.id}>{truck.name}-{truck.registrationNumber}</option>
                                                    )};
                                                </select>
                                            </td>
                                            <td className="table__text--align  table--cell--nowrap">
                                                <div className={multipleTrucksItem.isKwikstage ? "hidden" : ""}>
                                                    <input type='number' id="quantityScheduled" name="quantityScheduled" className='form-control allocate__qtySize' value={item.quantityScheduled} onChange={(e) => this.onCellChange(e, index)}></input>
                                                </div>
                                                <div className={multipleTrucksItem.isKwikstage && item.kwikstageItems.length > 0 ? "" : "hidden"}>
                                                    {item.kwikstageItems.map((ksItem, ksindex) =>
                                                        <div className="alignitemscentre" key={ksindex}>
                                                            <span>{ksItem.starterBay + " " + ksItem.lift.replace(" Platform", "")}</span>
                                                            <input type='number' id="bays" name="bays" className='form-control allocate__qtySize marginLeft10' value={ksItem.bays} onChange={(e) => this.onKwikstageCellChange(e, index, ksindex)}></input>
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                            <td className="table__text--align">
                                                <input type='text' pattern="(0?[0-9]|1[0-2])+\.[0-5][0-9]$" className="form-control allocate__qtySize" id="estimatedTime" name="estimatedTime" value={item.estimatedTime} onChange={(e) => this.onCellChange(e, index)} />
                                            </td>
                                            <td className="table__text--align">
                                                <div className={item.truckId === multipleTrucksItem.originalTruckId ? "hidden" : "delete--tablecell"}>
                                                    <a className="makeitred" href="#" onClick={(e) => this.deleteItem(e, index)}>
                                                        <span className="fas fa-times-circle edit--icon alignIconCenter"></span>
                                                    </a>
                                                </div>
                                            </td>

                                        </tr>

                                    )}
                                </tbody>
                            </table>
                            {this.state.errors["truckAllocation"] ?
                                (this.state.errors["truckAllocation"]).split("\n").map((item: any, key: any) => {
                                    return <span className="label errors" key={key}>{item}<br /></span>
                                })
                                : ""}
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <button className="popup-button--yes" onClick={this.save}>Save</button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }

}